<template>
	<el-row class="points-show">
		<el-row>
			<el-row>
				<el-col :span="5">
					<div class="search-view">
						<div>课件方向:</div>
						<el-select size="mini" class="margin-left-10" v-model="queryInfo.direction" clearable
							placeholder="全部">
							<el-option v-for="item in options" :key="item.value" :label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</div>
				</el-col>
				<el-col :span="7">
					<div class="search-view">
						<div>课件分类:</div>
						<el-cascader size="mini" class="margin-left-10 input" v-model="queryInfo.courseCategory"
							:options="options2" :props="cateListProps" clearable />
					</div>
				</el-col>
				<el-col :span="6">
					<div class="search-view">
						<div>是否付费:</div>
						<el-select size="mini" class="margin-left-10" v-model="queryInfo.free" clearable
							placeholder="全部">
							<el-option v-for="item in options3" :key="item.value" :label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</div>
				</el-col>
				<el-col :span="6">
					<div class="search-view">
						<div>上架状态:</div>
						<el-select size="mini" class="margin-left-10" v-model="queryInfo.status" clearable
							placeholder="全部">
							<el-option v-for="item in options4" :key="item.value" :label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</div>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="8">
					<div class="search-view">
						<div>发布日期:</div>
						<el-date-picker size="mini" style="margin-left: 10px" format="yyyy-MM-dd HH:mm:ss"
							value-format="yyyy-MM-dd HH:mm:ss" v-model="queryInfo.time" type="datetimerange"
							range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" align="right">
						</el-date-picker>
					</div>
				</el-col>
				<el-col :span="1">
					<el-button type="primary" size="mini" @click="shaixuan()">筛选</el-button>
				</el-col>
				<el-col :span="1">
					<el-button type="warning" size="mini" @click="zhikong()">置空</el-button>
				</el-col>
			</el-row>
			<el-col :span="24" style="margin-top: 30px;">
				<el-table :data="tableData" :header-cell-style="{ background: '#f2f2f2', color: '#666' }">
					<!-- <el-table-column label="序号">
						<template slot-scope="scope">
							{{scope.$index+1>9?scope.$index+1:"0"+(scope.$index+1)}}
						</template>
					</el-table-column> -->
					<el-table-column label="课件id" prop="courseId" width="70"></el-table-column>
					<el-table-column label="课件标题" prop="courseName"></el-table-column>
					<el-table-column label="类型" prop="type" width="70">
						<template slot-scope="scope">
							{{scope.row.publisherName ? '其他': '后台'}}
						</template>
					</el-table-column>
					<el-table-column label="课件节数" prop="num">
						<template slot-scope="scope">
							{{scope.row.num ? scope.row.num + '节课' : '暂无课件'}}
						</template>
					</el-table-column>
					<el-table-column label="方向" prop="directionName" width="100px"></el-table-column>
					<el-table-column label="分类" prop="courseCategoryName"></el-table-column>
					<el-table-column label="是否付费" prop="free" width="100">
						<template slot-scope="scope">
							{{scope.row.free == 0 ? '免费': scope.row.free == 1? "付费" : ''}}
						</template>
					</el-table-column>
					<el-table-column label="发布者" prop="publisherName" width="70">
						<template slot-scope="scope">
							{{scope.row.publisherName ? scope.row.publisherName :'后台'}}
						</template>
					</el-table-column>
					<el-table-column label="发布时间" prop="created"></el-table-column>
					<el-table-column label="操作" width="250">
						<template slot-scope="scope">
							<el-button type="text" style="color: #ff9e0d;" v-if="scope.row.status == 0"
								@click="sxjia(scope.row)">
								下架
							</el-button>
							<el-button type="text" style="color: #0066ff;" v-if="scope.row.status == 1"
								@click="sxjia(scope.row)">
								立即上架
							</el-button>
							<el-button type="text" style="color: #009900;" @click="view(scope.row)">查看课件</el-button>
							<el-button type="text" style="color: #0066ff;" @click="see(scope.row)">数据查看</el-button>
							<el-button type="text" style="color: #fd2881;" @click="del(scope.row)">删除</el-button>
						</template>
					</el-table-column>
				</el-table>
			</el-col>
		</el-row>
		<div style="margin: 20px auto;width: 500px">
			<el-pagination class="pagination" background layout="total, sizes,prev, pager, next,jumper"
				:page-size="pageSize" :page-sizes="pagelist" :total="total" :current-page.sync="pageNum"
				@size-change="handleSizeChange" @current-change="handleCurrentChange" />
		</div>
	</el-row>
</template>

<script>
	export default {
		data() {
			return {
				queryInfo: {
					direction: '', //课程方向）
					courseCategory: [],
					courseCategoryOne: "", //（一级类别）
					courseCategoryTwo: "", //二级类别
					free: '', //（0 免费， 1 付费） 
					status: "", //(0 上架， 1 下架)
					time: [],
					startTime: "", //(选择的起时间)
					endTime: "", //选择的止时间
				},
				options: [],
				options2: [],
				cateListProps: {
					value: "dicId", //匹配响应数据中的id
					label: "dicDesc", //匹配响应数据中的name
					children: "sonDicList", //匹配响应数据中的children
				},
				options3: [{
						value: 0,
						label: '免费',
					},
					{
						value: 1,
						label: '付费',
					}
				],
				options4: [{
						value: 0,
						label: '上架',
					},
					{
						value: 1,
						label: '下架',
					}
				],
				tableData: [],
				total: 0,
				pageNum: 1,
				pageSize: 10,
				pagelist: [10, 50, 100],
			}
		},
		methods: {
			zhikong() {
				this.queryInfo.direction = ""
				this.queryInfo.courseCategory = []
				this.queryInfo.courseCategoryOne = ""
				this.queryInfo.courseCategoryTwo = ""
				this.queryInfo.free = ""
				this.queryInfo.status = ""
				this.queryInfo.time = []
				this.queryInfo.startTime = ""
				this.queryInfo.endTime = ""
				this.getInfo()
			},
			shaixuan() {
				if (this.queryInfo.courseCategory.length > 0) {
					this.queryInfo.courseCategoryOne = this.queryInfo.courseCategory[0]
					this.queryInfo.courseCategoryTwo = this.queryInfo.courseCategory[1]
				} else {
					this.queryInfo.courseCategoryOne = ''
					this.queryInfo.courseCategoryTwo = ''
				}
				// console.log(this.queryInfo.time);
				if (this.queryInfo.time) {
					this.queryInfo.startTime = this.queryInfo.time[0]
					this.queryInfo.endTime = this.queryInfo.time[1]
				} else {
					this.queryInfo.startTime = ""
					this.queryInfo.endTime = ""
				}
				this.pageNum = 1;
				this.getInfo()
			},
			sxjia(row) {
				this.$confirm('此操作将改变上下架状态, 是否继续?', '上下架提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http.post(`/api/course/clrCourse/updateCourse`, {
						courseId: row.courseId,
						status: row.status == 0 ? 1 : 0
					}).then(res => {
						console.log(res.data.data);
						if (res.data.status == 0) {
							this.$message({
								type: 'success',
								message: res.data.data
							});
							this.getInfo()
						} else {
							this.$message.error('更新失败')
						}
					})

				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});
			},
			//查看课件
			view(row) {
				console.log(row);
				this.$router.push({
					path: './viewCourseware',
					query: {
						id: row.courseId
					}
				})
			},
			see(row) {
				console.log(row);
				this.$router.push({
					path: './viewDate',
					query: {
						courseId: row.courseId
					}
				})
			},
			del(row) {
				console.log(row);
				this.$confirm('此操作将永久删除该课件, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http.post(`/api/course/clrCourse/deleteCourse`, {
						courseId: row.courseId
					}).then(res => {
						if (res.data.status == 0) {
							this.$message({
								type: 'success',
								message: res.data.data
							});
							this.getInfo()
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			getInfo() {
				this.$http.post(`/api/course/clrCourse/selectCourse?pageNum=${this.pageNum}&pageSize=${this.pageSize}`, {
					"direction": this.queryInfo.direction,
					"courseCategoryOne": this.queryInfo.courseCategoryOne,
					"courseCategoryTwo": this.queryInfo.courseCategoryTwo,
					"free": this.queryInfo.free,
					"status": this.queryInfo.status,
					"startTime": this.queryInfo.startTime,
					"endTime": this.queryInfo.endTime,
				}).then(res => {
					console.log(res.data.data.list);
					this.tableData = res.data.data.list
					this.total = res.data.data.total
				})
			},
			//页面的条数发生改变时
			handleSizeChange(size) {
				this.pageSize = size
				//重新请求数据
				this.getInfo()
			},
			//当前页发生改变时
			handleCurrentChange(currentPage) {
				this.pageNum = currentPage
				//重新请求数据
				this.getInfo()
			},
			//方向
			getInfo2() {
				this.$http.get(`/api/setting/paiBoCategory/PaiBoCategoryDropDown?dicModular=405`, {}).then(res => {
					// console.log(res.data.data, "方向");
					if (res.data.data.length > 0) {
						res.data.data.forEach(i => {
							this.options.push({
								label: i.dicDesc,
								value: i.dicId
							})
						})
					}
				})

			},
			//类别
			getInfo3() {
				this.$http.get(`/api/setting/paiBoCategory/PaiBoCategoryDropDown?dicModular=82`, {}).then(res => {
					// console.log(res.data.data, "类别");
					if (res.data.data.length > 0) {
						res.data.data.forEach(i => {
							this.options2 = res.data.data
						})
					}
				})
			},
		},
		created() {
			this.getInfo()
			this.getInfo2()
			this.getInfo3()
		}
	}
</script>

<style scoped>
	.margin-left-10 {
		margin-left: 10px;
	}

	/deep/ .input .el-input__inner {
		width: 300px;
	}
</style>
